import React from 'react'
import styled from 'styled-components'
import themes from './themes'

const HeaderText = styled.h1`
margin:0;
font-size:33px;
font-weight:500;
line-height:1.3;
color:${themes.white};
text-align:center;
`;




function Header(props){
return(
<HeaderText {...props}>{props.children}</HeaderText>
)
}

export default Header